import api from "@/api/api";

const ensureQuestionAlias = (question, index = 0) => {
  if (!question || typeof question !== "object") {
    return question;
  }

  const alias = typeof question.alias === "string" ? question.alias.trim() : "";
  if (alias) {
    return question;
  }

  const suffix =
    question.id !== undefined && question.id !== null ? String(question.id) : String(index);

  return {
    ...question,
    alias: `question_${suffix}`,
  };
};

const normalizeQuestions = (questions) => {
  if (!questions) {
    return [];
  }

  if (Array.isArray(questions)) {
    return questions.map((q, index) => ensureQuestionAlias(q, index));
  }

  if (typeof questions === "object") {
    return Object.values(questions).map((q, index) => ensureQuestionAlias(q, index));
  }

  return [];
};

const getFormByType = async (type) => {
  const response = await api.get(`/forms?filters[type]=eq:${type}`);
  const form = response.data[0] || null;

  if (form && form.questions) {
    form.questions = normalizeQuestions(form.questions);
  }

  return form;
};

export const inquiryForm = () => getFormByType("consultation");
export const problemForm = () => getFormByType("complaint");

export default { inquiryForm, problemForm };
